import {createSlice} from '@reduxjs/toolkit';

const initialState = { chatMessage: '' };

export const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        appendChatMessage: (state, action) => {
            // 누적
            state.chatMessage += action.payload;
        },
        setChatMessage: (state, action) => {
            // 덮어쓰기
            state.chatMessage = action.payload;
        },
        clearChatMessage: (state) => {
            state.chatMessage = '';
        },
    },
});

export const { setChatMessage, clearChatMessage, appendChatMessage } = chatSlice.actions;
export default chatSlice.reducer;